var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z",
    fill: "#4A154B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7746 28.3041C17.7746 29.7572 16.6002 30.9315 15.1472 30.9315C13.6941 30.9315 12.5198 29.7572 12.5198 28.3041C12.5198 26.8511 13.6941 25.6768 15.1472 25.6768H17.7746V28.3041Z",
    fill: "#E01E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0887 28.3041C19.0887 26.8511 20.2631 25.6768 21.7161 25.6768C23.1692 25.6768 24.3435 26.8511 24.3435 28.3041V34.8726C24.3435 36.3256 23.1692 37.5 21.7161 37.5C20.2631 37.5 19.0887 36.3256 19.0887 34.8726V28.3041Z",
    fill: "#E01E5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7161 17.7548C20.2631 17.7548 19.0887 16.5804 19.0887 15.1274C19.0887 13.6744 20.2631 12.5 21.7161 12.5C23.1692 12.5 24.3435 13.6744 24.3435 15.1274V17.7548H21.7161Z",
    fill: "#36C5F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7158 19.0884C23.1688 19.0884 24.3432 20.2627 24.3432 21.7158C24.3432 23.1688 23.1688 24.3432 21.7158 24.3432H15.1274C13.6744 24.3432 12.5 23.1688 12.5 21.7158C12.5 20.2627 13.6744 19.0884 15.1274 19.0884H21.7158Z",
    fill: "#36C5F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2456 21.7158C32.2456 20.2627 33.42 19.0884 34.873 19.0884C36.326 19.0884 37.5004 20.2627 37.5004 21.7158C37.5004 23.1688 36.326 24.3432 34.873 24.3432H32.2456V21.7158Z",
    fill: "#2EB67D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9315 21.7158C30.9315 23.1688 29.7572 24.3432 28.3041 24.3432C26.8511 24.3432 25.6768 23.1688 25.6768 21.7158V15.1274C25.6768 13.6744 26.8511 12.5 28.3041 12.5C29.7572 12.5 30.9315 13.6744 30.9315 15.1274V21.7158Z",
    fill: "#2EB67D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3041 32.2451C29.7572 32.2451 30.9315 33.4195 30.9315 34.8725C30.9315 36.3255 29.7572 37.4999 28.3041 37.4999C26.8511 37.4999 25.6768 36.3255 25.6768 34.8725V32.2451H28.3041Z",
    fill: "#ECB22E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3041 30.9315C26.8511 30.9315 25.6768 29.7572 25.6768 28.3041C25.6768 26.8511 26.8511 25.6768 28.3041 25.6768H34.8925C36.3455 25.6768 37.5199 26.8511 37.5199 28.3041C37.5199 29.7572 36.3455 30.9315 34.8925 30.9315H28.3041Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.2b4560c7be36fc4e23ae22522cbf6f32.svg";
export { ForwardRef as ReactComponent };